import { render, staticRenderFns } from "./ItemsManagementWrapper.vue?vue&type=template&id=09b52314&scoped=true"
import script from "./ItemsManagementWrapper.vue?vue&type=script&lang=js"
export * from "./ItemsManagementWrapper.vue?vue&type=script&lang=js"
import style0 from "./ItemsManagementWrapper.vue?vue&type=style&index=0&id=09b52314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b52314",
  null
  
)

export default component.exports